import React from 'react';
import PropTypes from 'prop-types';
import Platform from '../shared/Platform';

export default function ProfessionalPresence({ professionalPresence }) {
    if (!professionalPresence.length) { return null; }

    return (
        <div className="social-media-platforms">
            <h3>{i18n.t('seller_profile.professional_presence')}</h3>
            <ul>
                {professionalPresence.map((platform, idx) =>
                    <Platform platformData={platform} key={idx}/>)}
            </ul>
        </div>
    );
}

ProfessionalPresence.propTypes = {
    professionalPresence: PropTypes.array
};

ProfessionalPresence.defaultProps = {
    professionalPresence: []
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/ProfessionalPresence/index.js